import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { tilesShip } from '../tiles/tilesShip-sidecar'
import { rando } from '../lib/rando-sidecar'
import { asteroidPerlin } from './asteroidPerlin-sidecar'
import { AsteroidType } from '../tiles/tilesShip'
import { l } from '../lib/imports'

export function generateBigAsteroid(i: number, j: number) {
  // let size = rando.i(7, 14)
  let size = 20

  let ctx = scene.getContext()
  let std = tilesDataShip.getStandard()

  asteroidPerlin.create(size, size, (ii, jj, sim) => {
    if (sim > 0) {
      // console.log('ssss', sim)
      let t = tileMapShip.getTile(ctx.mapShip, i + ii, j + jj)
      if (t) {
        let type: AsteroidType = 'rock'

        if (rando.chance(0.05)) {
          type = 'ice'
        } else if (rando.chance(0.1)) {
          type = 'iron'
        }

        tilesShip.setAsteroidFloor(t, sim, type)
      }
    }
  })

  // for (let ij = 0; ij < size; ij++) {
  //   for (let ii = 0; ii < size; ii++) {}
  // }
}
